import React from 'react';

import { Spin } from 'antd';

import { ACCOUNT_STATUSES } from '@src/models/interfaces/accountStatus.interface';
import { useAccountStatus } from '@src/packages/utils';

import { AccountCancelled } from '../../screens/AccountCancelled';
import { AccountStatusBanner } from '../AccountStatusBanner';

interface AccountStatusContentProps {
  children: React.ReactNode;
}

/** The organization's screens under its account notice; a block screen once cancelled. */
export const AccountStatusContent: React.FC<AccountStatusContentProps> = ({ children }) => {
  const { snapshot, loaded } = useAccountStatus();

  // Wait for the first status: otherwise a cancelled organization's screens, and create actions
  // of a read-only one, flash before the status arrives.
  if (!loaded) {
    return <Spin className="gx-w-100 gx-mt-4" />;
  }

  if (snapshot.status === ACCOUNT_STATUSES.CANCELLED) {
    return <AccountCancelled />;
  }

  return (
    <>
      <AccountStatusBanner />
      {children}
    </>
  );
};
